import Form from "../components/login/Form";

export default function Login() {
  return (
    <div className="w-full h-screen bg-white">
      <div className="w-full h-full hidden md:grid md:grid-cols-2">
        <div className="col-span-1 bg-black flex items-center justify-center bg-[url(/images/bg-login.webp)] bg-cover bg-center">
          <img src="/images/logo-essilor-luxottica.svg" alt="essilor-logo" />
        </div>
        <div className="col-span-1 flex items-center justify-center">
          <Form />
        </div>
      </div>
      <div className="flex items-center justify-center md:hidden h-full">
        <Form />
      </div>
    </div>
  );
}
